import "./style.css"

const Main = () => {
    return ( 
            <div id="wait-cursor">
              <div className="loader"></div>
            </div>
     );
}
 
export default Main;